import safeCreateAction from "../../../actions/safeCreateAction";
/**
 * Set the result of a health check
 */
export const setHealthCheckResult = safeCreateAction("SET_HEALTH_CHECK_RESULT", (checkId, result) => ({ checkId, result }));
/**
 * Clear a specific health check result
 */
export const clearHealthCheckResult = safeCreateAction("CLEAR_HEALTH_CHECK_RESULT", (checkId) => checkId);
/**
 * Clear all health check results
 */
export const clearAllHealthCheckResults = safeCreateAction("CLEAR_ALL_HEALTH_CHECK_RESULTS", () => undefined);
/**
 * Set whether a health check is currently running
 */
export const setHealthCheckRunning = safeCreateAction("SET_HEALTH_CHECK_RUNNING", (checkId, running) => ({ checkId, running }));
/**
 * Set mod files in cache
 */
export const setModFiles = safeCreateAction("SET_MOD_FILES", (modId, files) => ({ modId, files }));
/**
 * Set whether mod files are being loaded
 */
export const setModFilesLoading = safeCreateAction("SET_MOD_FILES_LOADING", (modId, loading) => ({ modId, loading }));
